import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import { useTranslate } from '../../hooks/useTranslate';

const SectionDetailsMaybe = props => {
  const { listingId, lastFetch, publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  const { translation } = useTranslate(
    Object.fromEntries(existingListingFields.map(d => [d.key, { label: d.label, value: d.value }])),
    listingId ? `listing-page-${listingId}` : 'listing-page',
    lastFetch,
    existingListingFields.length
  );

  //   existingListingFields,
  //   Object.fromEntries(existingListingFields.map(d => [d.key, d.value])),
  //   Object.fromEntries(existingListingFields.map(d => [d.key, d.label]))
  // );
  // const { translation: valueTrans } = useTranslate(
  //   Object.fromEntries(existingListingFields.map(d => [d.key, d.value]))
  // );

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields?.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>
              {translation[detail.key]?.label || detail.label}
            </span>
            <span> {translation[detail.key]?.value || detail.value}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
